<script lang="ts">
    /** This components makes sure that container element gets inserted into DOM
     * before showing its content, that allows making animations smooth. Before
     * rendering elements a setTimeout is called to make sure render won't happen
     * in this cycle of UI update.
     *
     * Initialization happens once.
     */
    export let initializedContent = false;
    export let initializedContainer = false;
    export let show = false;
    export let dataElement: string | undefined = undefined;
    export let visibleClass = "";
    export let hiddenClass = "";

    let isVisible = false;
    $: {
        if (!show) {
            isVisible = false;
            setTimeout(() => {
                initializedContent = false;
            });
        } else {
            setTimeout(() => {
                isVisible = true;
            });
            setTimeout(() => {
                // initialize inner content in next thread activity
                initializedContent = true;
            });
            if (!initializedContainer) {
                initializedContainer = true;
            }
        }
    }
</script>

{#if initializedContainer}
    <div
        data-element={dataElement}
        class={`${$$props.class || ''} ${isVisible ? visibleClass : hiddenClass}`}>
        {#if initializedContent}
            <slot />
        {/if}
    </div>
{/if}
